import React, { useContext, useEffect, useState } from 'react'
import cn from 'classnames'
import styles from './UploadDetails.module.sass'
import Icon from '../../components/Icon'
import TextInput from '../../components/TextInput'
import Switch from '../../components/Switch'
import Loader from '../../components/Loader'
import Modal from '../../components/Modal'
import Preview from './Preview'
import FollowSteps from '../../components/FollowSteps'
import { Button, message, Select, Upload } from 'antd'
import 'antd/dist/antd.css'
import { UploadOutlined } from '@ant-design/icons'
import { get, post } from '../../adapters/api'
import { getContracts } from '../../adapters/eth'
import { Web3Context } from '../../contexts/Web3Context'
import Connect from '../../components/Connect'
import SwitchNetwork from '../../components/ConnectMetamask/SwitchNetwork'
import TextArea from '../../components/TextArea'
import getVideoId from 'get-video-id'
import config from '../../config'

const maxPreviewFiles = 10

message.config({ top: 100, duration: 5, maxCount: 3, })
//todo: превью обновлять по ходу изменений!!!

const UploadScreen = () => {
  const [sale, setSale] = useState(true)
  const [visibleModal, setVisibleModal] = useState(false)
  const [filePreview, setFilePreview] = useState()
  const [fileContent, setFileContent] = useState(false)
  const [valueName, setValueName] = useState('')
  const [valueVideo, setValueVideo] = useState('')
  const [valueDescription, setValueDescription] = useState('')
  const [valuePrice, setValuePrice] = useState('')
  const [submitResult, setSubmitResult] = useState()
  const [valueCategories, setValueCategories] = useState([])
  const [categories, setCategories] = useState(false)
  const [showLoader, setShowLoader] = useState(false)
  const [fileList, setFileList] = useState([])
  const [tokenData, setTokenData] = useState({})
  const [tempoPrev, setTempoPrev] = useState()
  const [alarma, setAlarma] = useState('')

  const [previewVisible, setPreviewVisible] = useState(0)

  const { web3, defaultAccount, isConnected, isCorrectNetwork } = useContext(Web3Context)

  useEffect(() => {
    (async () => {
      try {
        const catList = await get('token/categories')

        const { Option } = Select
        let cats = []
        for (let i of catList.data) {
          cats.push(<Option key={i.id} value={i.id}>{i.category}</Option>)
        }
        setCategories(cats)
      } catch (e) {
      }
    })()
    const failSavedValues = sessionStorage.getItem('failSaveValues')
    if (failSavedValues) {
      const saved = JSON.parse(failSavedValues)

      setValueName(saved.valueName)
      setValueVideo(saved.valueVideo)
      setValueDescription(saved.valueDescription)
      setValuePrice(saved.valuePrice)
      setValueCategories(saved.valueCategories)
      const tokenData = {
        valueName: saved.valueName,
        valueVideo: saved.valueVideo,
        valueDescription: saved.valueDescription,
        valuePrice: saved.valuePrice,
        valueSellTill: saved.valueSellTill,
        valueCategories: saved.valueCategories,
      }
      setTokenData(tokenData)

    }
    setPreviewVisible(1)
  }, [])

  useEffect(() => {
    if (tempoPrev) {
      let result = filePreview || []
      result.push(tempoPrev)
      result = result.slice(0, maxPreviewFiles)
      setFilePreview(result)
      tokenData.filePreview = result
      tokenData.preview = result.slice(0, 1).pop()
      setTokenData(tokenData)
      setPreviewVisible(Math.random())
    }
  }, [tempoPrev])

  const tryAgain = () => {
    setVisibleModal(false)
    setSubmitResult('')
    setShowLoader(false)
  }

  const prepareFile = async (file) => {
    return await new Promise(resolve => {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => resolve(reader.result)
    })
  }

  //Content handlers
  const onBeforeContentUpload = async info => {
    const fileData = await prepareFile(info)
    setFileContent(fileData)
    return false
  }

  const onUploadContentRemove = () => {
    setFileContent(false)
  }
  //End Content handlers

  //Preview handlers
  const onBeforeFileListUpload = async info => {
    setAlarma('')
    const fileData = await prepareFile(info)
    setTempoPrev(fileData)
    return false
  }

  const onUploadFileListChange = async (info) => {
    setFileList(info.fileList)
    if (!tokenData.preview) {
      const preview = info.fileList.slice(0, 1).pop()
      if (preview) {
        if (!preview.url && !preview.preview) {
          preview.preview = await getBase64(preview.originFileObj)
        }
        tokenData.preview = preview.url || preview.preview
        setTokenData(tokenData)
        setPreviewVisible(Math.random())
      }
    }
  }

  const onUploadFileListRemove = (deleted) => {
    setFilePreview()
    tokenData.filePreview = []
    if (deleted.preview === tokenData.preview) {
      tokenData.preview = null
    }
    setTokenData(tokenData)
    setPreviewVisible(Math.random())
    setFileList([])
  }

  function getBase64 (file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => resolve(reader.result)
      reader.onerror = error => reject(error)
    })
  }

  const onUploadFileListPreview = async file => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj)
    }
    const fileURL = file.url || file.preview

    const files = tokenData.filePreview

    tokenData.preview = fileURL
    files.splice(files.indexOf(fileURL), 1)
    files.unshift(fileURL)
    tokenData.filePreview = files

    setTokenData(tokenData)
    setPreviewVisible(Math.random())
  }
  //END Preview handlers

  const handleChangeName = event => {
    const name = event.target.value
    setValueName(name)
    tokenData.valueName = name
    setTokenData(tokenData)
    setPreviewVisible(Math.random())
  }

  const handleChangeVideo = event => {
    const id = getVideoId(event.target.value)
    if (id.service === 'youtube') {
      setValueVideo('https://www.youtube.com/embed/' + id.id)
    }
    tokenData.valueVideo = valueVideo
    setTokenData(tokenData)
    setPreviewVisible(Math.random())
  }

  const handleChangeDescription = event => {
    setValueDescription(event.target.value)
    tokenData.valueDescription = valueDescription
    setTokenData(tokenData)
    setPreviewVisible(Math.random())
  }

  const handleChangePrice = event => {
    const price = event.target.value.replace(',', '.')
    setValuePrice(price)
    tokenData.valuePrice = price
    setTokenData(tokenData)
    setPreviewVisible(Math.random())
  }

  const submitNewNft = async (event) => {
    event.preventDefault()

    if (!filePreview) {
      setAlarma('requiredUploadFiles')
      window.scrollTo({
        top: 210,
        left: 0,
        behavior: 'smooth'
      })
      return
    }

    setShowLoader(true)
    sessionStorage.removeItem('failSaveValues')

    try {
      const contracts = await getContracts(web3)

      const dur = new Audio(filePreview[0])

      const result = await post('token/create', {
        preview: filePreview,
        content: fileContent,
        name: valueName,
        video: valueVideo,
        description: valueDescription,
        price: valuePrice,
        from: defaultAccount,
        categories: valueCategories,
        duration: isNaN(dur.duration) ? 0 : dur.duration
      })

      contracts.Nft.methods.safeMint(defaultAccount, result.data.uri).send({ from: defaultAccount })
        .once('receipt', async (receipt) => {
          const delay = ms => new Promise(resolve => setTimeout(resolve, ms))
          await delay(3000)
          setShowLoader(false)
          console.log('=== receipt ===', receipt)
          if (sale) {
            setVisibleModal(true)
            setSubmitResult(result.data)
          } else {
            message.success('Your NFT minted successfully!')
            window.location.href = '/profile'
          }
        })
        .on('error', e => {
          setShowLoader(false)
          console.log(e)
          message.error('Error on submitting new NFT!')
          return false
        })
    } catch (e) {
      setShowLoader(false)
      console.log(e)
      sessionStorage.setItem('failSaveValues', JSON.stringify({
        valueName,
        valueVideo,
        valueDescription,
        valuePrice,
        valueCategories
      }))
      message.error('Error on submitting new NFT!')
      return false
    }
  }

  const handleCategoriesChange = selected => {
    setValueCategories(selected)
  }

  return (
    <>
      <div className={cn('section', styles.section)}>
        <div className={cn('container', styles.container)}>
          <div className={styles.wrapper}>
            <div className={styles.head}>
              <div className={cn('h2', styles.title)}>
                Upload NFT
              </div>
            </div>
            {isConnected && !isCorrectNetwork && <SwitchNetwork/>}
            {!isConnected && <Connect/>}
            {isConnected && isCorrectNetwork &&
              <form className={styles.form} onSubmit={submitNewNft}>
                <div className={styles.list}>
                  <div className={styles.item}>
                    <div className={styles.category}>Upload file*</div>
                    <div className={styles.note}>
                      Drag or choose your file to upload (max {maxPreviewFiles} files, total max size
                      100 Mb)
                    </div>

                    <br/>
                    <Upload
                      listType="picture-card"
                      fileList={fileList}
                      maxCount={maxPreviewFiles}
                      multiple={true}
                      beforeUpload={onBeforeFileListUpload}
                      onChange={onUploadFileListChange}
                      onPreview={onUploadFileListPreview}
                      onRemove={onUploadFileListRemove}
                      className={alarma}
                    >
                      {fileList.length < maxPreviewFiles && '+ Upload'}
                    </Upload>
                  </div>

                  <div className={styles.item}>
                    <div className={styles.category}>Main Content</div>
                    <div className={styles.note}>
                      This content will be available after user buy NFT
                    </div>
                    <br/>

                    <Upload
                      listType="picture"
                      beforeUpload={onBeforeContentUpload}
                      onRemove={onUploadContentRemove}
                      maxCount={1}
                    >
                      <Button icon={<UploadOutlined/>}>Upload Main Content</Button>
                    </Upload>

                  </div>

                  <div className={styles.item}>
                    <div className={styles.category}>Item Details</div>
                    <div className={styles.fieldset}>
                      <TextInput
                        className={styles.field}
                        label="Item name*"
                        name="name"
                        type="text"
                        placeholder='e. g. Redeemable Bitcoin Card with logo"'
                        required
                        value={valueName}
                        onChange={handleChangeName}
                      />
                      <TextArea
                        className={styles.field}
                        label="Description*"
                        name="description"
                        placeholder="e. g. “After purchasing you will able to received the logo...”"
                        required
                        value={valueDescription}
                        onChange={handleChangeDescription}
                      />
                      <TextInput
                        className={styles.field}
                        label="Youtube Video (optional)"
                        name="name"
                        type="text"
                        placeholder="Insert Youtube Video about your token if you have it"
                        value={valueVideo}
                        onChange={handleChangeVideo}
                      />
                    </div>
                  </div>

                  <div>
                    <div className={styles.col_full}>
                      <div className={styles.field}>
                        <div className={styles.label}>Select Categories</div>
                        <Select
                          mode="multiple"
                          allowClear
                          size="large"
                          value={valueCategories}
                          style={{ width: '100%' }}
                          placeholder="Please select categories"
                          onChange={handleCategoriesChange}
                          className="antSelect-rounded"
                        >
                          {categories}
                        </Select>
                      </div>
                    </div>
                  </div>


                </div>
                <div className={styles.options}>
                  <div className={styles.option}>
                    <div className={styles.box}>
                      <div className={styles.category}>Put on sale</div>
                      <div className={styles.text}>
                        You’ll receive bids on this item
                      </div>
                    </div>
                    <Switch value={sale} setValue={setSale}/>
                  </div>

                  {sale &&
                    <div className={styles.row}>
                      <div className={styles.col}>
                        <TextInput
                          className={styles.field}
                          label={'Price* (in ' + config.symbolName + ')'}
                          name="price"
                          type="text"
                          placeholder="e. g. 1.5"
                          required
                          value={valuePrice}
                          onChange={handleChangePrice}
                        />
                      </div>
                    </div>
                  }
                </div>
                <div className={styles.foot}>
                  {isConnected && isCorrectNetwork && defaultAccount &&
                    <button className={cn('button', styles.button)} type="submit">
                      <span>Create item</span>
                      <Icon name="arrow-next" size="10"/>
                    </button>
                  }
                  {showLoader &&
                    <div className={styles.saving}>
                      <span>Publishing</span>
                      <Loader className={styles.loader}/>
                    </div>
                  }
                </div>
              </form>}
          </div>

          <div className={cn(styles.preview_wrapper)}>
            {previewVisible && <Preview
              className={cn(styles.preview, styles.active)}
              tokenData={tokenData}
            />}
          </div>

        </div>
      </div>
      <Modal visible={visibleModal && submitResult} onClose={() => setVisibleModal(false)}>
        {isConnected && isCorrectNetwork && <FollowSteps
          className={styles.steps}
          instructions={submitResult}
          parentCallback={tryAgain}
        />}
      </Modal>
    </>
  )
}

export default UploadScreen
